import React, { useState } from "react";
import {
  Backdrop,
  Button,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
} from "../../../../../components";
import JobDetailsModal from "./JobDetailsModal";
import { useSelector } from "react-redux";
import { bulkUploadApi } from "../../../../../redux/slices/leads/leadsApi";
import { formatWords2 } from "../../../../../utils/stringUtils";

const ImportModal = ({
  onCancel,
  parsedData = [],
  setParsedData,
  callFetchTodaysCompanies,
  unmatchedCount,
  onJobCountUpdate
}) => {
  const [showActions, setShowActions] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editRowData, setEditRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state?.auth);
  const columns = [
    {
      key: "companyName",
      label: "Company Name",
    },
    {
      key: "jobDetails", label: "Job Details", getRowClass: (row) => {
        // Example conditions for row styling
        if (row._rowClass) {
          return "bg-amber-500";
        }
        return ""; // Default case
      },
    },
    {
      key: "contactDetails",
      label: "Contact Details",
      render: (row) => (
        <div className="flex flex-col gap-2">
          {row?.contactDetails.map((detail) => (
            <div className="flex gap-6">
              <p>{detail?.name}</p>
              <p>{detail?.phone}</p>
              {/* <p>{detail?.email?.email}</p> */}
              <p>
                {typeof detail?.email === "string"
                  ? detail.email
                  : detail?.email?.email}
              </p>

            </div>
          ))}
        </div>
      ),
    },
    // { key: "locations", label: "Locations" },
    // {
    //   key: "email",
    //   label: "Email",
    //   render: (row) =>
    //     row.email?.map((email, idx) => (
    //       <div key={idx} className="flex flex-col">
    //         {email}
    //       </div>
    //     )),
    // },
    // {
    //   key: "email",
    //   label: "Email",
    //   render: (row) => {
    //     if (!row.email) return <div>-</div>;

    //     // Ensure always a string
    //     const safeEmail =
    //       typeof row.email === "string" ? row.email : String(row.email);

    //     return safeEmail.split("\n").map((email, idx) => (
    //       <div key={idx} className="flex flex-col">
    //         {email}
    //       </div>
    //     ));
    //   },
    // },

    // {
    //   key: "phoneNumber",
    //   label: "Phone Number",
    // },
    {
      key: "",
      label: "Actions",
      render: (row) =>
        // showActions ? (
        //   <div className="flex gap-3">
        //     <Button
        //       type="icon"
        //       icon="edit_square"
        //       size="xs"
        //       color="black"
        //       variant="text"
        //       onClick={() => handleEditClick(row)}
        //     />
        //     <Button
        //       type="icon"
        //       icon="delete"
        //       size="xs"
        //       color="black"
        //       variant="text "
        //     />
        //   </div>
        // ) : (
        //   <Button
        //     onClick={() => handleDeleteProspects(row)}
        //     type="icon"
        //     icon="close"
        //     size="xs"
        //     className="!rounded"
        //   />
        // ),
        <div className="flex flex-col">
          {/* {row.contactDetails.map((detail,idx) => (
          <Button
            type="icon"
            icon={"delete"}
            color="black"
            variant="text"
            size="sm"
            onClick={() => handleDeleteProspects(row.fullData.companyId, idx)}
          />
        ))} */}
          {row?.fullData?.Prospects?.map((p, idx) => (
            <div key={idx}>
              {/* {!p.uiid && ( */}
              {(!p?.uiid || (p?.addedOn && new Date(p?.addedOn).toDateString() === new Date().toDateString())) && (
                <Button
                  type="icon"
                  icon="delete"
                  color="black"
                  variant="text"
                  size="sm"
                  onClick={() => handleDeleteProspects(row?.fullData?.companyId, idx)}
                />
              )}
            </div>
          ))}
        </div>
    },
  ];
  // const handleDeleteProspects = (row) => {
  //   const companyId = row.fullData.companyId;

  //   setParsedData((prev) =>
  //     prev.map((company) =>
  //       company.companyId === companyId
  //         ? { ...company, Prospects: [] }
  //         : company
  //     )
  //   );
  // };
  // console.log("row",parsedData)
  const handleDeleteProspects = (companyId, contactIndex) => {
    setParsedData((prev) =>
      prev.map((company) =>
        company.companyId === companyId
          ? {
            ...company,
            Prospects: company.Prospects.filter(
              (_, idx) => idx !== contactIndex
            ),
          }
          : company
      )
    );
  };

  const getMobileObject = (p) => {
    let raw = "";

    // Extract value safely from different possible fields
    if (p.phone) raw = p.phone;
    else if (p.contactPhone) raw = p.contactPhone;
    else if (p.phoneNumber) raw = p.phoneNumber;
    else return { code: "+91", number: null };

    // Convert to string and clean up unwanted characters
    let value = String(raw).trim();

    // Remove wrapping quotes or apostrophes (Excel sometimes adds these)
    value = value.replace(/^['"]+|['"]+$/g, "");

    // Replace comma or dash separators with space
    value = value.replace(/[,-]+/g, " ").replace(/\s+/g, " ").trim();

    // Now match patterns like "+33 142278123", "33 142278123", "+33,142278123"
    const match = value.match(/^(\+?\d{1,4})?\s*(\d{5,15})$/);

    let code = "";
    let number = "";

    if (match) {
      code = match[1] ? (match[1].startsWith("+") ? match[1] : `+${match[1]}`) : "+91";
      number = match[2];
    } else {
      // fallback if phone is just digits
      const digits = value.replace(/\D/g, "");
      code = "+91";
      number = digits;
    }

    // Convert number to numeric type (for backend validation)
    const numericNumber = Number(number);

    return { code, number: numericNumber };
  };

  const normalizePhone = (p) => {
    if (Array.isArray(p.phone)) return p.phone.join(", ");
    if (typeof p.phone === "object" && p.phone !== null) {
      if (p.phone.code || p.phone.number) {
        return `${p.phone.code || ""} ${p.phone.number || ""}`.trim();
      }
      return JSON.stringify(p.phone);
    }
    return p.phone || "";
  };
  // const rows = parsedData.map((company, idx) => {
  //   const prospects = company.Prospects || [];

  //   return {
  //     id: `${company.companyId}-${idx}`,
  //     companyName: company.companyName || "-",
  //     jobDetails: company.website ? `${company.website}` : "No Job",
  //     locations:
  //       prospects.length > 0
  //         ? prospects
  //             .map((p) =>
  //               typeof p.location === "object"
  //                 ? `${p.location.city || ""}, ${p.location.state || ""}, ${
  //                     p.location.country || ""
  //                   }`
  //                 : p.location || "-"
  //             )
  //             .join("\n")
  //         : "-",
  //     email:
  //       prospects.length > 0
  //         ? prospects.map((p) => p.email || "-").join("\n")
  //         : "-",
  //     phoneNumber:
  //       prospects.length > 0
  //         ? prospects.map((p) => p.phone || "-").join("\n")
  //         : "-",

  //     //  Store the full dataset here
  //     fullData: company,
  //   };
  // });
  // const handleSave = () => {
  //   if (!showActions) {
  //     setShowActions(true);
  //   } else {
  //     onCancel();
  //   }
  // };
  const rows = parsedData.map((company, idx) => {
    const prospects = company?.Prospects || [];
    const hasNoJob = !company?.jobId && !company?.website;
    const hasNoProspects = prospects?.length === 0;
    const highlight = hasNoJob || hasNoProspects;

    return {
      id: `${company?.companyId}-${idx}`,
      // companyName: company?.companyName || "-",
      companyName: company?.companyName ? formatWords2(company?.companyName) : "-",
      // jobDetails: company?.website ? `${company?.website}` : "No Job",
      jobDetails:
        // company?.jobDescription ||
        // company?.website ||
        formatWords2(company?.jobTitle || "No Job"),
      locations:
        prospects.length > 0
          ? prospects
            .map((p) =>
              typeof p.location === "object"
                ? `${p?.location?.city || ""}, ${p?.location?.state || ""}, ${p?.location?.country || ""
                }`
                : p?.location || "-"
            )
            .join("\n")
          : "-",
      email:
        prospects?.length > 0
          ? prospects.map((p) => p?.email || "-").join("\n")
          : "-",
      phoneNumber:
        prospects.length > 0
          ? prospects.map((p) => p?.phone || "-").join("\n")
          : "-",
      // 👇 Add this so Actions + ContactDetails column works
      contactDetails: prospects.map((p) => ({
        name: `${formatWords2(p?.firstName || "")} ${formatWords2(p?.lastName || "")}`.trim(),
        phone: Array.isArray(p?.phone)
          ? p.phone.join(", ")
          : typeof p.phone === "object"
            ? JSON.stringify(p?.phone)
            : p.phone || "",
        email: p?.email || "",
      })),

      fullData: company,
      _rowClass: highlight,
    };
  }).sort((a, b) => Number(b._rowClass) - Number(a._rowClass));


  const highlightCount = rows?.filter((row) => row?._rowClass)?.length || 0;

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = parsedData.map((company) => ({
        companyId: company?.companyId,
        jobId: company?.jobId || null,
        Procepects: (company?.Prospects || []).map((p) => {
          let locationObj = { city: "", state: "", country: "" };

          if (typeof p.location === "string") {
            const parts = p?.location.split(",").map((s) => s.trim());
            locationObj = {
              city: parts[0] || "",
              state: parts[1] || "",
              country: parts[2] || "",
            };
          } else if (typeof p.location === "object" && p?.location !== null) {
            locationObj = {
              city: p?.location?.city || "",
              state: p?.location?.state || "",
              country: p?.location?.country || "",
            };
          }
          // let code = "";
          // let number = "";

          // if (p.phone) {
          //   const parts = String(p.phone).trim().split(" ");
          //   if (parts.length === 2) {
          //     code = parts[0];
          //     number = parts[1];
          //   } else {
          //     code = "+91"; // default for India (or detect dynamically)
          //     number = parts[0];
          //   }
          // }
          const { code, number } = getMobileObject(p);
          return {
            companyId: company?.companyId,
            jobId: company?.jobId || null,
            // uiid: p.uiid || undefined,
            ...(p.uiid && !isNaN(Number(p.uiid)) ? { uiid: Number(p.uiid) } : {}),
            // email: p.email,
            email: {
              email: p?.email,
            },
            firstName: p?.firstName || "",
            lastName: p?.lastName || "",
            designation: p?.designation || "",
            addedBy: user.data?.uiid,
            location: locationObj,
            // phone: p.phone || "",
            // mobile: { code, number },
            // mobile: getMobileObject(p),
            ...(getMobileObject(p)?.number && getMobileObject(p).number !== 0
              ? { mobile: getMobileObject(p) }
              : {}),
          };
        }),
      }));
      const res = await bulkUploadApi({ payload });
      if (res?.data) {
        showToast("Updated successfully", "success", 2000);
        if (res?.data?.data?.waitingPeriodNotCompleted?.length > 0) {
          let waitingPeriodNotCompleted = res?.data?.data?.waitingPeriodNotCompleted;
          waitingPeriodNotCompleted = waitingPeriodNotCompleted.map(item => item.email).join(", ");
          showToast(`Waiting period not completed for these emails: ${waitingPeriodNotCompleted}`, "error", 20000);
        }
        if (res?.data?.data?.blockedProspects?.length > 0) {
          let blockedProspects = res?.data?.data?.blockedProspects;
          blockedProspects = blockedProspects.map(item => item.email).join(", ");
          showToast(`Invalid or Blocked Emails: ${blockedProspects}`, "error", 20000);
        }
        if (res?.data?.data?.invalidEmails?.length > 0) {
          let invalidEmails = res?.data?.data?.invalidEmails;
          invalidEmails = invalidEmails.map(item => item.email).join(", ");
          showToast(`Invalid Emails: ${invalidEmails}`, "error", 20000);
        }

      } else {
        showToast(res?.error || "failed to bulk upload", "error");
      }
      onCancel(); // close modal after save
      callFetchTodaysCompanies();
      onJobCountUpdate?.();
    } catch (err) {
      console.error("Bulk upload failed", err);
    } finally {
      setLoading(false);
    }
  };
  const handleEditClick = (row) => {
    const company = row?.fullData;
    const prospects = company?.Prospects || [];

    const mappedData = {
      id: company?.jobId || null,
      website: company?.website || "",
      jobDescription: company?.jobDescription || "",
      jobTitle: company?.title || company?.jobTitle || "",
      companyId: company?.companyId,
      jobLocation: company?.jobLocation
        ? `${company?.jobLocation?.city || ""}, ${company?.jobLocation?.state || ""
        }, ${company?.jobLocation?.country || ""}`
        : "",

      industry: company?.industry || "",

      contactDetails: prospects.map((p) => {
        let locationObj = { city: "", state: "", country: "" };
        if (typeof p.location === "string") {
          const parts = p.location.split(",").map((s) => s.trim());
          locationObj = {
            city: parts[0] || "",
            state: parts[1] || "",
            country: parts[2] || "",
          };
        } else if (typeof p.location === "object" && p.location !== null) {
          locationObj = {
            city: p?.location?.city || "",
            state: p?.location?.state || "",
            country: p?.location?.country || "",
          };
        }
        return {
          name: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
          designation: p?.designation || "",
          email: p?.email || "",
          // phone:
          //   p.mobile?.code || p.mobile?.number
          //     ? `${p.mobile.code || ""} ${p.mobile.number || ""}`.trim()
          //     : p.phone || "",
          phone: Array.isArray(p.phone)
            ? p?.phone.join(", ")
            : typeof p.phone === "object"
              ? JSON.stringify(p?.phone) // avoid [object Object]
              : p?.phone || "",
          location: locationObj,
          uiid: p?.uiid || null,
          isCsv: !p?.uiid,
        };
      }),
    };

    setEditRowData(mappedData);
    setOpenEditModal(true);
  };
  const handleEditClose = (updatedData) => {
    if (!updatedData) {
      setOpenEditModal(false);
      setEditRowData(null);
      return;
    }

    const hasDbProspects = updatedData?.Prospects?.some((p) => p.uiid);

    if (hasDbProspects) {
      setParsedData((prev) =>
        prev.map((company) =>
          company.companyId === updatedData.companyId
            ? { ...company, ...updatedData }
            : company
        )
      );
    } else {
      setParsedData((prev) =>
        prev.map((company) =>
          company.companyId === updatedData.companyId
            ? { ...company, ...updatedData }
            : company
        )
      );
    }

    setOpenEditModal(false);
    setEditRowData(null);
  };
  const unmatchedCount1 =
    parsedData?.filter((company) => {
      const hasNoJob = !company.jobId && !company.website;
      const hasNoProspects = !company?.Prospects || company?.Prospects.length === 0;
      return hasNoJob && hasNoProspects;
    }).length || 0;

  return (
    <div className="flex flex-col">
      <div className="h-150 overflow-auto">
        <TableAdv
          columns={columns}
          showSlNo
          rows={rows}
          // tdClassName="!py-3"
          tdClassName="!py-3 whitespace-pre-line"
          tableId={"leads_myleads_openmodaltable"}
          toolbarRight={{
            search: false,
            filter: false,
            download: false,
            fullScreen: true,
            add: [
              {
                component: (
                  <div className="p-2 bg-white border border-gray-100 shadow-md rounded-lg">
                    <span>No Matches Records: {highlightCount}</span>
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
      <div className="flex justify-end items-center gap-4 mt-4">
        <Button
          title={"Cancel"}
          variant="outlined"
          color="black"
          onClick={() => onCancel()}
        />
        <Button
          title={"Save"}
          // onClick={() => onCancel()}
          onClick={handleSave}
        />
        {/* <Button
          title={showActions ? "Save" : "Edit"}
          onClick={() => setShowActions((prev) => !prev)}
        /> */}
      </div>
      <Modal
        title="Edit Lead"
        isOpen={openEditModal}
        onClose={handleEditClose}
        width="max-w-5xl"
      >
        {editRowData ? (
          <JobDetailsModal
            data={editRowData}
            companyId={editRowData?.companyId}
            onClose={handleEditClose}
            callFetchTodaysCompanies={callFetchTodaysCompanies}
            onSave={handleEditClose}
          />
        ) : (
          <div className="flex justify-center py-10">Loading...</div>
        )}
      </Modal>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default ImportModal;
